import { handleHeadsUpVisibility } from '../src/widgetManager/utils/handleHeadsupVisibility.js'
import { handleWidgetVisibility } from '../src/widgetManager/utils/handleWidgetVisibility.js'
import { handleIconVisibility } from '../src/widgetManager/utils/handleIconVisibility.js'
import { getAdditionalSettingValue } from '../src/utils/getAdditionalSettingValue.js'
import { handleViewChange } from '../src/widgetManager/utils/handleViewChange.js'
import { handleTabChange } from '../src/widgetManager/utils/handleTabChange.js'
import interestQuerySoundUrl from '../src/assets/audio/interest-query.mp3'
import { SingleChannelBehavior } from './enums/single-channel-behavior'
import cookieConsentManager from './services/cookie-consent-manager'
import { patternMap } from '../src/assets/patterns/patternMap.js'
import GenesysVideoChannel from 'app/channels/genesys-video.js'
import { scrollMessages } from '../src/utils/scrollMessages.js'
import { widgetManager } from '../src/widgetManager/index.js'
import translations from '../config/locales/translations.js'
import TrueengageLogger from './services/trueengage-logger'
import { channelFactory } from './channels/factory.js'
import ChannelPicker from './channel-picker'
import intlTelInput from 'intl-tel-input'
import CallPopover from './callPopover'
import templates from './templates'
import Popover from './popover'
import Bubble from './bubble'
import _ from 'underscore'

// import MobileDetect from "mobile-detect";

const logger = new TrueengageLogger()
function capitalize(string) {
  return string.charAt(0).toUpperCase() + string.slice(1)
}

export default class Widget {
  constructor(
    container,
    $element,
    settings,
    usingPredictiveEngagement,
    {
      callbackService,
      genesysWebMessengerHistoryService,
      genesysCallbackService,
      genesysAudioService,
      billingService,
      tokenService,
      whatsappService,
      facebookMessengerService,
      genesysVideoService,
      genesysKnowledgeBaseService,
      formSubmissionService,
      widgetIndex,
    }
  ) {
    logger.info({ widgetSettings: settings })
    this.rendered = false
    this.container = container
    this.state = 'closed'
    this.firedTriggerIds = []
    this.channelButtonListenerAdded = false
    this.isMessengerOpen = false
    this.isQuickRepliesActive = settings.headsUpType === 'quickReplies'
    this.facebookBilled = false
    this.billingService = billingService
    this.formSubmissionService = formSubmissionService
    this.additionalChannels = container.settings.additionalChannels
    this.additionalBackendChannels = container.settings.additionalBackendChannels
    this.genesysVideoService = genesysVideoService
    this.usingPredictiveEngagement = usingPredictiveEngagement
    this.isFormInitialized = false
    this.styleNamespace = 'cce-widget'
    this.initalizedChannels = []

    this.singleChannelBehavior = SingleChannelBehavior.OPEN_CHANNEL
    this.headsupAlreadyShown = false
    let localSingleChannelBehavior = localStorage.getItem('single-channel')
    if (settings.singleChannelBehavior === '1') {
      this.singleChannelBehavior = SingleChannelBehavior.OPEN_PICKER
    }
    if (localSingleChannelBehavior) {
      if (localSingleChannelBehavior.toString() === '1') {
        this.singleChannelBehavior = SingleChannelBehavior.OPEN_PICKER
      } else {
        this.singleChannelBehavior = SingleChannelBehavior.OPEN_CHANNEL
      }
    }
    this.widgetIndex = widgetIndex

    const rightToLeftLanguages = ['ar', 'ar-ae', 'he', 'ur']
    this.$widgetContainerElement = $element
    this.$windowElement = this.$widgetContainerElement.getElementsByClassName('cce-widget__window__container')[0]
    if (rightToLeftLanguages.includes(settings.locale)) {
      this.$mainWindowElement = this.$widgetContainerElement.getElementsByClassName('cce-widget__window')[0]
      this.$mainWindowElement.classList.add('text-rtl')
    }
    this.$windowContentElement = this.$widgetContainerElement.getElementsByClassName('cce-widget__window__content')[0]
    this.$windowElementOpenChannel = this.$widgetContainerElement.getElementsByClassName('cce-widget__window__footer')
    this.$windowElementHeader = this.$widgetContainerElement.getElementsByClassName('cce-widget__window__header')[0]
    this.$bubbleElement = null

    this.setSettings(settings)

    window.addEventListener('scroll', () => {
      this.handleScroll()
    })
    this.i18n = translations[settings.locale]

    this.channels = []

    this.additionalBackendChannels = this.settings.channels.filter((channel) => channel.displayType === 'custom')
    this.settings.channels = this.settings.channels.filter((channel) => channel.displayType !== 'custom')

    if (this.additionalBackendChannels) {
      this.additionalBackendChannels.forEach((c) => {
        let isFormio = false
        let formDefinition = null
        try {
          formDefinition = JSON.parse(c.params.script)
          isFormio = formDefinition.components
        } catch (e) {
          isFormio = c.params.form
          formDefinition = c.params.form
        }

        if (isFormio) {
          const formioScript = document.createElement('script')
          formioScript.src = 'https://cdn.form.io/formiojs/formio.form.min.js'
          document.head.appendChild(formioScript)

          const formioStyle = document.createElement('link')
          formioStyle.href = 'https://cdn.form.io/formiojs/formio.form.min.css'
          formioStyle.rel = 'stylesheet'
          document.head.appendChild(formioStyle)

          const fontAwesome = document.createElement('link')
          fontAwesome.href = 'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.css'
          fontAwesome.rel = 'stylesheet'
          document.head.appendChild(fontAwesome)

          const $widgetForm = templates.formTemplate(this.getFormTemplateVariables(c.params.texts, c.params.translations))
          document.body.insertAdjacentHTML('afterbegin', $widgetForm)
        }

        this.settings.channels.push({
          type: 'custom',
          displayType: 'custom',
          customName: c.params.customName,
          id: c.id,
          action: () => {
            if (isFormio && !this.isFormInitialized) {
              const formioContainer = document.querySelector('.trueengage-formio')
              const formioContainerOverlay = document.querySelector('.trueengage-formio-overlay')

              Formio.createForm(document.getElementById('trueengage-formio-content'), formDefinition, c.params.translations).then((form) => {
                this.initializeFormButtons(form)

                form.on('submit', (submission) => {
                  const data = {
                    form_guid: c.params.formGuid,
                    data: submission.data,
                    account_id: this.container.settings.id,
                    metadata: submission.metadata,
                    url: location.href,
                    widget_channel_id: c.id,
                  }
                  this.formSubmissionService.submitForm({ form: data }, () => {
                    formioContainer.classList.add('complete')
                  })
                  this.triggerPublicEvent('widget_business_success', { state: widgetManager.getState(), confirmed: true })
                  form.submission = {}
                  form.resetValue()
                  form.refresh()
                })
                this.isFormInitialized = true
              })
              formioContainer.style.display = 'flex'
              formioContainerOverlay.style.display = 'block'
            } else if (isFormio && this.isFormInitialized) {
              const formioContainer = document.querySelector('.trueengage-formio')
              const formioContainerOverlay = document.querySelector('.trueengage-formio-overlay')

              formioContainerOverlay.style.display = 'block'
              formioContainer.style.display = 'flex'
              formioContainer.classList.remove('complete')
            } else {
              eval(c.params.script)
            }
          },
          icon: {
            html:
              c.params.customName === 'form'
                ? '<svg width="20" height="20" viewBox="0 0 24 24" fill="#171754" xmlns="http://www.w3.org/2000/svg">\n' +
                  '<g clip-path="url(#clip0_3302_32327)">\n' +
                  '<path d="M10.5 3.75C10.5 3.55109 10.579 3.36032 10.7197 3.21967C10.8603 3.07902 11.0511 3 11.25 3H21.75C21.9489 3 22.1397 3.07902 22.2803 3.21967C22.421 3.36032 22.5 3.55109 22.5 3.75V5.25C22.5 5.44891 22.421 5.63968 22.2803 5.78033C22.1397 5.92098 21.9489 6 21.75 6H11.25C11.0511 6 10.8603 5.92098 10.7197 5.78033C10.579 5.63968 10.5 5.44891 10.5 5.25V3.75ZM3 1.5C2.20435 1.5 1.44129 1.81607 0.87868 2.37868C0.316071 2.94129 0 3.70435 0 4.5L0 7.5C0 8.29565 0.316071 9.05871 0.87868 9.62132C1.44129 10.1839 2.20435 10.5 3 10.5H6C6.79565 10.5 7.55871 10.1839 8.12132 9.62132C8.68393 9.05871 9 8.29565 9 7.5V4.5C9 3.70435 8.68393 2.94129 8.12132 2.37868C7.55871 1.81607 6.79565 1.5 6 1.5H3ZM3 13.5C2.20435 13.5 1.44129 13.8161 0.87868 14.3787C0.316071 14.9413 0 15.7044 0 16.5L0 19.5C0 20.2956 0.316071 21.0587 0.87868 21.6213C1.44129 22.1839 2.20435 22.5 3 22.5H6C6.79565 22.5 7.55871 22.1839 8.12132 21.6213C8.68393 21.0587 9 20.2956 9 19.5V16.5C9 15.7044 8.68393 14.9413 8.12132 14.3787C7.55871 13.8161 6.79565 13.5 6 13.5H3ZM4.281 8.031C4.21133 8.10084 4.12857 8.15626 4.03745 8.19407C3.94633 8.23188 3.84865 8.25134 3.75 8.25134C3.65135 8.25134 3.55367 8.23188 3.46255 8.19407C3.37143 8.15626 3.28867 8.10084 3.219 8.031L1.719 6.531C1.64927 6.46127 1.59395 6.37848 1.55622 6.28738C1.51848 6.19627 1.49905 6.09862 1.49905 6C1.49905 5.90138 1.51848 5.80373 1.55622 5.71263C1.59395 5.62152 1.64927 5.53873 1.719 5.469C1.78873 5.39927 1.87152 5.34395 1.96262 5.30622C2.05373 5.26848 2.15138 5.24905 2.25 5.24905C2.34862 5.24905 2.44627 5.26848 2.53737 5.30622C2.62848 5.34395 2.71127 5.39927 2.781 5.469L3.75 6.4395L6.219 3.969C6.28873 3.89927 6.37152 3.84395 6.46262 3.80622C6.55373 3.76848 6.65138 3.74905 6.75 3.74905C6.84862 3.74905 6.94627 3.76848 7.03738 3.80622C7.12848 3.84395 7.21127 3.89927 7.281 3.969C7.35073 4.03873 7.40605 4.12152 7.44379 4.21263C7.48152 4.30373 7.50095 4.40138 7.50095 4.5C7.50095 4.59862 7.48152 4.69627 7.44379 4.78737C7.40605 4.87848 7.35073 4.96127 7.281 5.031L4.281 8.031ZM4.281 20.031C4.21133 20.1008 4.12857 20.1563 4.03745 20.1941C3.94633 20.2319 3.84865 20.2513 3.75 20.2513C3.65135 20.2513 3.55367 20.2319 3.46255 20.1941C3.37143 20.1563 3.28867 20.1008 3.219 20.031L1.719 18.531C1.57817 18.3902 1.49905 18.1992 1.49905 18C1.49905 17.8008 1.57817 17.6098 1.719 17.469C1.85983 17.3282 2.05084 17.2491 2.25 17.2491C2.44916 17.2491 2.64017 17.3282 2.781 17.469L3.75 18.4395L6.219 15.969C6.35983 15.8282 6.55084 15.7491 6.75 15.7491C6.94916 15.7491 7.14017 15.8282 7.281 15.969C7.42183 16.1098 7.50095 16.3008 7.50095 16.5C7.50095 16.6992 7.42183 16.8902 7.281 17.031L4.281 20.031ZM10.5 15.75C10.5 15.5511 10.579 15.3603 10.7197 15.2197C10.8603 15.079 11.0511 15 11.25 15H21.75C21.9489 15 22.1397 15.079 22.2803 15.2197C22.421 15.3603 22.5 15.5511 22.5 15.75V17.25C22.5 17.4489 22.421 17.6397 22.2803 17.7803C22.1397 17.921 21.9489 18 21.75 18H11.25C11.0511 18 10.8603 17.921 10.7197 17.7803C10.579 17.6397 10.5 17.4489 10.5 17.25V15.75ZM10.5 8.25C10.5 8.05109 10.579 7.86032 10.7197 7.71967C10.8603 7.57902 11.0511 7.5 11.25 7.5H18.75C18.9489 7.5 19.1397 7.57902 19.2803 7.71967C19.421 7.86032 19.5 8.05109 19.5 8.25C19.5 8.44891 19.421 8.63968 19.2803 8.78033C19.1397 8.92098 18.9489 9 18.75 9H11.25C11.0511 9 10.8603 8.92098 10.7197 8.78033C10.579 8.63968 10.5 8.44891 10.5 8.25ZM10.5 20.25C10.5 20.0511 10.579 19.8603 10.7197 19.7197C10.8603 19.579 11.0511 19.5 11.25 19.5H18.75C18.9489 19.5 19.1397 19.579 19.2803 19.7197C19.421 19.8603 19.5 20.0511 19.5 20.25C19.5 20.4489 19.421 20.6397 19.2803 20.7803C19.1397 20.921 18.9489 21 18.75 21H11.25C11.0511 21 10.8603 20.921 10.7197 20.7803C10.579 20.6397 10.5 20.4489 10.5 20.25Z" fill="currentColor"/>\n' +
                  '</g>\n' +
                  '<defs>\n' +
                  '<clipPath id="clip0_3302_32327">\n' +
                  '<rect width="24" height="24" fill="white"/>\n' +
                  '</clipPath>\n' +
                  '</defs>\n' +
                  '</svg>'
                : '<svg width="18" height="18" viewBox="0 0 24 24" fill="#171754" xmlns="http://www.w3.org/2000/svg">\n' +
                  '<g clip-path="url(#clip0_3302_32325)">\n' +
                  '<path d="M6 0.75C6 0.551088 5.92098 0.360322 5.78033 0.21967C5.63968 0.0790176 5.44891 0 5.25 0C5.05109 0 4.86032 0.0790176 4.71967 0.21967C4.57902 0.360322 4.5 0.551088 4.5 0.75V1.5H3C2.20435 1.5 1.44129 1.81607 0.87868 2.37868C0.316071 2.94129 0 3.70435 0 4.5L0 6H24V4.5C24 3.70435 23.6839 2.94129 23.1213 2.37868C22.5587 1.81607 21.7956 1.5 21 1.5H19.5V0.75C19.5 0.551088 19.421 0.360322 19.2803 0.21967C19.1397 0.0790176 18.9489 0 18.75 0C18.5511 0 18.3603 0.0790176 18.2197 0.21967C18.079 0.360322 18 0.551088 18 0.75V1.5H6V0.75ZM24 21V7.5H0V21C0 21.7956 0.316071 22.5587 0.87868 23.1213C1.44129 23.6839 2.20435 24 3 24H21C21.7956 24 22.5587 23.6839 23.1213 23.1213C23.6839 22.5587 24 21.7956 24 21ZM16.281 13.281L11.781 17.781C11.7113 17.8508 11.6286 17.9063 11.5375 17.9441C11.4463 17.9819 11.3487 18.0013 11.25 18.0013C11.1513 18.0013 11.0537 17.9819 10.9625 17.9441C10.8714 17.9063 10.7887 17.8508 10.719 17.781L8.469 15.531C8.32817 15.3902 8.24905 15.1992 8.24905 15C8.24905 14.8008 8.32817 14.6098 8.469 14.469C8.60983 14.3282 8.80084 14.2491 9 14.2491C9.19916 14.2491 9.39017 14.3282 9.531 14.469L11.25 16.1895L15.219 12.219C15.3598 12.0782 15.5508 11.9991 15.75 11.9991C15.9492 11.9991 16.1402 12.0782 16.281 12.219C16.4218 12.3598 16.5009 12.5508 16.5009 12.75C16.5009 12.9492 16.4218 13.1402 16.281 13.281Z" fill="currentColor"/>\n' +
                  '</g>\n' +
                  '<defs>\n' +
                  '<clipPath id="clip0_3302_32325">\n' +
                  '<rect width="24" height="24" fill="white"/>\n' +
                  '</clipPath>\n' +
                  '</defs>\n' +
                  '</svg>',
          },
        })
      })
    }

    const widgetContainsCustomChannel = this.settings.channels.some((x) => x.type === 'custom')
    if (this.additionalChannels && !widgetContainsCustomChannel) {
      let maxId = Math.max(...this.settings.channels.map((x) => x.id))
      this.additionalChannels.forEach((c) => {
        this.settings.channels.push({
          type: 'custom',
          displayType: 'custom',
          id: ++maxId,
          action: c.action,
          icon: c.icon,
          headline: c.headline,
          description: c.description,
        })
      })
    }

    this.settings.channels.forEach((channelSettings) => {
      const showVideoBlur = this.settings.additionalSettings.find((item) => item.key === 'default_visitor_blur')

      if (channelSettings.type === 'genesysAudio' || channelSettings.type === 'genesysVideo') {
        channelSettings.fields.push({
          avatars: settings.agentGraphics,
          showVideoBlur: showVideoBlur ? showVideoBlur.value : false,
        })
      }
      const showChatTranscript = this.settings.additionalSettings.find((item) => item.key === 'chat_transcript')

      if (channelSettings.type === 'genesysWebMessenger') {
        channelSettings.fields.push({
          isQuickRepliesActive: this.isQuickRepliesActive,
          headsUpType: this.settings.headsUpType,
          onChannelSelected: () => this.handleOpenChatWithQuickReply(),
          showChatTranscript: showChatTranscript ? showChatTranscript.value : false,
          usingPredictiveEngagement: usingPredictiveEngagement,
          handleUpgradeChat: (channelType) => this.handleUpgradeChat(channelType),
        })
      }

      this.channels.push(
        channelFactory(channelSettings, {
          i18n: this.i18n,
          callbackService,
          genesysWebMessengerHistoryService,
          genesysCallbackService,
          genesysAudioService,
          genesysVideoService,
          billingService,
          tokenService,
          widgetContainer: this.container,
          texts: settings.texts,
          agentImage: this.settings.agentGraphics[0],
          botImage: this.settings.botGraphic,
          isMobile: this.isMobile,
          whatsappService,
          facebookMessengerService,
          triggers: this.settings.triggers,
          widgetIndex,
          singleChannelBehavior: this.singleChannelBehavior,
          genesysKnowledgeBaseService,
          showNotification: this.showNotification,
          preInteractionForm: this.settings.preInteractionForm,
          validatePreInteractionForm: this.validatePreInteractionForm,
          initPreInteractionForm: this.initPreInteractionForm,
          adjustPreInteractionFormConsentsStyles: this.adjustPreInteractionFormConsentsStyles,
          interactionForms: this.settings.interactionForms,
        })
      )
    })

    // init bubble
    this.bubble = new Bubble({
      icon: this.settings.icon,
      onClick: () => this.handleBubbleClicked(),
      widgetContainer: this.container,
      handleCallWindow: this.handleCallWindow,
      widgetId: this.settings.id,
    })
    this.$bubbleElement = this.bubble.$element
    this.$widgetContainerElement.append(this.$bubbleElement)

    // init popover
    this.popover = new Popover({
      icon: this.settings.icon,
      onClick: () => this.handleBubbleClicked(),
      i18n: this.i18n,
      text1: this.settings.texts.find((t) => t.type === 'general' && t.key === 'headsUpTitle').value,
      text2: this.settings.texts.find((t) => t.type === 'general' && t.key === 'headsUpText').value,
      placement: this.settings.headsUpPlacement.toLowerCase(),
      iconSrc: this.settings.headsUpGraphics,
      widgetContainer: this.container,
      widgetIndex: widgetIndex,
    })
    this.$widgetContainerElement.append(this.popover.$element)

    // init active call popover
    this.callPopover = new CallPopover({
      agentAvatar: this.settings.agentGraphics[1],
      onClick: () => this.handleBubbleClicked(),
      texts: this.settings.texts,
      widgetContainer: this.container,
      handleCallWindow: this.handleCallWindow,
    })
    this.$widgetContainerElement.append(this.callPopover.$element)

    let channelOrder = this.settings.additionalSettings.find((item) => item.key === 'channel_order')

    // init channel picker
    this.channelPicker = new ChannelPicker({
      name: 'content',
      template: templates.channelPicker,
      onClosed: () => this.handleChannelPickerClosed(),
      channels: this.settings.channels,
      i18n: this.i18n,
      texts: this.settings.texts,
      widgetId: this.settings.id,
      widgetContainer: this.container,
      singleChannelBehavior: this.singleChannelBehavior,
      channelOrder: channelOrder,
      preInteractionForm: this.settings.preInteractionForm,
    })

    //init channel picker footer
    this.channelPickerFooter = new ChannelPicker({
      name: 'footer',
      template: templates.channelPickerFooter,
      onClosed: () => this.handleChannelPickerClosed(),
      channels: this.settings.channels,
      i18n: this.i18n,
      texts: this.settings.texts,
      widgetId: this.settings.id,
      widgetContainer: this.container,
      singleChannelBehavior: this.singleChannelBehavior,
      channelOrder: channelOrder,
      preInteractionForm: this.settings.preInteractionForm,
    })

    this.$windowElementOpenChannel[0].prepend(this.channelPickerFooter.$element)
    this.$windowContentElement.append(this.channelPicker.$element)

    this.triggerSound = new Audio(interestQuerySoundUrl)
    this.availableTabs = ['audio', 'video', 'scheduledVideo', 'chat', 'callback', 'whatsapp', 'facebookMessenger', 'meetingSchedule', 'form', 'faq']
    this.observeWidgetManagerChanges()
    this.render()
  }

  observeWidgetManagerChanges() {
    const singleChannel = this.channels.length === 1 && this.singleChannelBehavior === SingleChannelBehavior.OPEN_CHANNEL

    document.addEventListener('trueengage:remove_audio_channel_initalize', (e) => {
      const videoChannel = this.settings.channels.find((ch) => ch.displayType === 'video')
      this.initalizedChannels = this.initalizedChannels.filter((channel) => channel !== videoChannel.id)
    })

    // handle tab change
    widgetManager.subscribe(
      (state) => state.widget_tab,
      (current, previous) => {
        const [, tab = null, view = null] = current?.split('.') || []
        const [, previousTab = null, previousView = null] = previous?.split('.') || []

        const isChannelPickerOpen = tab === 'channel_picker'
        const tabChanged = tab !== previousTab
        const viewChanged = view !== previousView

        if (isChannelPickerOpen) {
          if (tabChanged) handleTabChange(tab, singleChannel)
          if (viewChanged) handleViewChange(tab, view, previousView, singleChannel)
          return
        }

        const typeMap = {
          callMeNow: 'callback',
          genesysWhatsapp: 'whatsapp',
          facebook: 'facebookMessenger',
        }

        const displayType = typeMap[tab] || tab
        let channel
        if (tab === 'form' || tab === 'meetingSchedule') {
          channel = this.settings.channels.find((ch) => ch.customName === tab)
        } else {
          channel = this.settings.channels.find((ch) => (typeMap[ch.displayType] || ch.displayType) === displayType)
        }
        const selectedChannel = this.channels.find((ch) => ch.id === channel?.id)

        if (channel && !this.initalizedChannels.includes(channel.id)) {
          let showInput = getAdditionalSettingValue(this.settings.additionalSettings, 'show_input_message_view')
          showInput = showInput ?? true
          const { channelType } = selectedChannel || {}

          const isSocial = channelType === 'whatsapp' || channelType === 'facebookMessenger'

          if (isSocial && !showInput) {
            selectedChannel?.open(true)
            widgetManager.setWidgetTab('trueengage.channel_picker')
            return
          }

          if (selectedChannel.channelType === 'custom') {
            selectedChannel.open(selectedChannel.id)
          } else {
            selectedChannel.open()
          }

          if (selectedChannel.channelType !== 'custom') {
            this.$windowContentElement.append(selectedChannel.$element)
            this.initalizedChannels.push(selectedChannel.id)
          }
        }

        if (tab !== previousTab) {
          handleTabChange(tab, singleChannel)
        }

        if (view !== previousView) {
          const callMeNowActive = this.channels.find((channel) => channel.channelType === 'callback')?.callMeNowActive
          handleViewChange(tab, view, previousView, singleChannel, callMeNowActive)
        }
      }
    )

    // handle open single channel without view change
    widgetManager.subscribe(
      (state) => state.active_channel,
      (id) => {
        if (!id) return
        const channel = this.channels.find((ch) => ch.id === id)

        if (!this.initalizedChannels.includes(id)) {
          channel.open()
          if (channel.channelType === 'custom') return
          this.$windowContentElement.append(channel.$element)
          this.initalizedChannels.push(id)
        }
      }
    )

    // handle icon display
    widgetManager.subscribe(
      (state) => state.icon_visibility,
      (visible) => {
        handleIconVisibility(visible)
      }
    )

    // handle widget minimize
    widgetManager.subscribe(
      (state) => state.widget_visibility,
      (visible) => {
        this.headsupAlreadyShown = visible || this.headsupAlreadyShown

        const bubbleButton = document.querySelector('.cce-widget__bubble')
        const bubbleButtonText = document.querySelector('.cce-widget__button-text')

        if (bubbleButtonText && !bubbleButton?.classList.contains('cce-widget__bubble--with-channel')) {
          bubbleButtonText.classList.toggle('cce-widget__button-text-show', !visible)
        }

        handleWidgetVisibility(visible)
        this.handleCallWindow(visible)

        cookieConsentManager.setLocalStorageItem(`trueengage-widget-opened-${this.settings.id}`, visible, 'necessary')
        cookieConsentManager.setLocalStorageItem('trueengage-widget-minimized', !visible, 'necessary')
      }
    )

    // handle chat notification
    widgetManager.subscribe(
      (state) => [state.widget_visibility, state.widget_tab],
      ([visible, tab]) => {
        if (visible && tab === 'trueengage.chat') {
          const notificationDivs = document.querySelectorAll('.chat__notification')
          notificationDivs.forEach((notificationDiv) => {
            if (Number(notificationDiv.textContent) > 0) scrollMessages()
            notificationDiv.textContent = '0'
            notificationDiv.classList.remove('chat__notification-show')
          })
        }
      }
    )

    // handle headsup display
    widgetManager.subscribe(
      (state) => state.headsup_visibility,
      (visible) => {
        if (visible) {
          this.popover.open()
        }
        handleHeadsUpVisibility(visible)
      }
    )
  }

  initializeFormButtons(form) {
    const formioContainer = document.querySelector('.trueengage-formio')
    const formioContainerOverlay = document.querySelector('.trueengage-formio-overlay')
    const submitButton = document.querySelector('.trueengage-formio-footer-submit')
    const footerCloseButton = document.querySelector('.trueengage-formio-footer-close')
    const headerCloseButton = document.querySelector('.trueengage-formio-header-close')

    if (submitButton) {
      submitButton.addEventListener('click', async () => {
        await form.submit()
      })
    }

    if (footerCloseButton) {
      footerCloseButton.addEventListener('click', async () => {
        formioContainerOverlay.style.display = 'none'
        formioContainer.style.display = 'none'
        formioContainer.classList.remove('complete')
        widgetManager.closeWidget()
        widgetManager.setWidgetTab('trueengage.channel_picker')
      })
    }

    if (headerCloseButton) {
      headerCloseButton.addEventListener('click', async () => {
        formioContainer.style.display = 'none'
        formioContainerOverlay.style.display = 'none'
        formioContainer.classList.remove('complete')
        widgetManager.closeWidget()
        widgetManager.setWidgetTab('trueengage.channel_picker')
      })
    }
  }

  validatePreInteractionForm(channel, itiInput, texts) {
    const formToValidate = document.querySelector(`.cce-widget-${channel}__pre-interaction-form form`)
    if (!formToValidate) return false
    let errorTexts = texts
    let isValid = true

    const defaultErrorTexts = {
      invalidEmailAddress: 'Invalid email address',
      invalidPhoneNumber: 'Invalid phone number',
      requiredField: 'Required field',
    }

    Object.keys(defaultErrorTexts).forEach((key) => {
      if (!errorTexts.hasOwnProperty(key)) {
        errorTexts[key] = defaultErrorTexts[key]
      }
    })

    formToValidate.querySelectorAll('input').forEach((input) => {
      if (!input.required && (input.name !== 'emailAddress' || input.name !== 'phoneNumber')) {
        return
      }
      const label = input.closest('label')

      if (input.type === 'checkbox') {
        if (!input.checked) {
          label.classList.add('error')
          isValid = false
        } else {
          label.classList.remove('error')
        }

        input.addEventListener(
          'change',
          function () {
            if (input.checked) {
              label.classList.remove('error')
            }
          },
          { once: true }
        )
      } else {
        if (!input.value.trim()) {
          label.classList.add('error')
          const errorSpan = label.querySelector('.error')
          if (errorSpan) {
            errorSpan.textContent = errorTexts.requiredField
          }
          isValid = false
        } else {
          label.classList.remove('error')
        }

        input.addEventListener(
          'input',
          function () {
            label.classList.remove('error')
          },
          { once: true }
        )
      }

      if (input.name === 'emailAddress' && input.value.length > 0) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
        if (!emailRegex.test(input.value)) {
          isValid = false
          label.classList.add('error')
          const errorSpan = label.querySelector('.error')
          if (errorSpan) {
            errorSpan.textContent = errorTexts.invalidEmailAddress
          }
        }
      }
    })

    if (itiInput && !itiInput.isValidNumber()) {
      const label = formToValidate.querySelector(`.cce-widget__pre-interaction-form-phoneNumber`)
      const phoneInput = label.querySelector(`input`)

      if (phoneInput) {
        phoneInput.addEventListener('input', () => label.classList.remove('error'), { once: true })
      }

      if ((label && phoneInput.required && phoneInput.value.length > 0) || phoneInput.value.length > 0) {
        label.classList.add('error')

        const errorSpan = label.querySelector('.error')
        if (errorSpan) {
          errorSpan.textContent = errorTexts.invalidPhoneNumber
        }
        isValid = false
      }
    }

    return isValid
  }

  initPreInteractionForm(channel, initialCountry, placeholderText) {
    let itiForm
    const formElement = document.querySelector(`.cce-widget-${channel}__pre-interaction-form`)
    if (!formElement) return

    let dropdownContainer = formElement.querySelector('.cce-widget__pre-interaction-form-phoneNumber')

    if (dropdownContainer) {
      const options = {
        initialCountry: initialCountry,
        loadUtils: () => import('https://cdn.jsdelivr.net/npm/intl-tel-input@25.3.1/build/js/utils.js'),
        separateDialCode: true,
        countrySearch: true,
        fixDropdownWidth: true,
        useFullscreenPopup: false,
      }

      const elem = dropdownContainer.querySelector(`input`)
      itiForm = intlTelInput(elem, options)
      const dropdown = formElement.querySelector('.iti__dropdown-content')
      const itiSearchInput = formElement.querySelector(` .iti__search-input`)
      if (itiSearchInput) {
        itiSearchInput.placeholder = placeholderText
      }
      dropdown.querySelector('ul').addEventListener('click', (e) => {
        e.stopPropagation()
        e.preventDefault()
        dropdown.classList.add('iti__hide')
      })
    }

    const topicLabel = formElement.querySelector('.cce-widget__pre-interaction-form-topicList')

    if (topicLabel) {
      const topicInput = topicLabel.querySelector('input')
      const topicList = topicLabel.querySelector('ul')

      topicInput.addEventListener('click', () => {
        topicList.classList.toggle('show')
      })

      const topicItems = topicList.querySelectorAll('li')
      topicItems.forEach((item) => {
        item.addEventListener('click', (e) => {
          e.preventDefault()
          topicInput.value = item.textContent.trim()

          topicItems.forEach((i) => i.classList.remove('selected'))

          item.classList.add('selected')

          topicList.classList.remove('show')
          topicLabel.classList.remove('error')
        })
      })
      if (topicItems.length > 0) {
        topicItems[0].click()
      }
    }

    return itiForm
  }

  adjustPreInteractionFormConsentsStyles(channel) {
    const formElement = document.querySelector(`.cce-widget-${channel}__pre-interaction-form`)
    if (!formElement) return
    formElement.querySelectorAll(`.consents`).forEach((container) => {
      const text = container.querySelector('.content-text')
      const aTag = container.querySelector('a')

      if (text.offsetHeight > 22 || aTag.offsetHeight > 0) {
        container.classList.add('moreLines')
      }
    })
  }

  getFormTemplateVariables(texts, translations) {
    let logoStatus = 'off'
    let logotype = 'background'
    let logoUrl = ''

    function normalizeLocale(locale) {
      if (!locale.includes('-')) {
        return locale
      }

      const parts = locale.split('-')
      return parts[0] + parts[1][0].toUpperCase() + parts[1].slice(1)
    }

    if (this.settings.logo) {
      if (this.settings.logo.status) {
        logoStatus = this.settings.logo.status
      }
      if (this.settings.logo.url) {
        logoUrl = this.settings.logo.url
      }
      if (this.settings.logo.type) {
        logotype = this.settings.logo.type
      }
    }

    texts = texts || {}
    texts.header = texts.header || {}

    texts.header.titleBarText = texts.header.titleBarText || 'Hello 👋'
    texts.header.bodyBarText = texts.header.bodyBarText || 'How can we help you?\n'

    return {
      translations: translations.i18n[normalizeLocale(translations.language)],
      texts: texts,
      channels: this.settings.channels,
      logoStatus: logoStatus,
      logoUrl: logoUrl,
      logoType: logotype,
    }
  }

  async initVideoFromChatChannel(type) {
    const showVideoBlur = this.settings.additionalSettings.find((item) => item.key === 'default_visitor_blur')
    const settings = { fields: [] }
    settings.fields.push({
      avatars: this.settings.agentGraphics,
      showVideoBlur: showVideoBlur ? showVideoBlur.value : false,
    })

    this.initGenesysVideoChatChannel = new GenesysVideoChannel(settings, {
      i18n: this.i18n,
      texts: this.settings.texts,
      widgetContainer: this.container,
      genesysVideoService: this.genesysVideoService,
      singleChannelBehavior: this.singleChannelBehavior,
      chatCall: true,
      justVoice: type === 'AudioOffer',
      widgetIndex: this.widgetIndex,
    })

    await this.initGenesysVideoChatChannel.open(type === 'AudioOffer')
    const windowContent = document.querySelector('.cce-widget__window__content')
    this.channelPicker.close()
    windowContent.append(this.initGenesysVideoChatChannel.$element)
  }

  getChatId() {
    const chatChannel = this.settings.channels.find((channel) => channel.displayType === 'chat')

    if (chatChannel && chatChannel.id) {
      return chatChannel.id
    } else {
      return null
    }
  }

  setSettings(settings) {
    this.settings = Object.assign({}, this.settings, this.defaultSettings, settings)
    this.settings.triggers.forEach((trigger) => {
      return this.toggleState(trigger.component + '-trigger-' + trigger.kind)
    })

    this.toggleState(`placement-${this.settings.placement}`, true)
    this.setCustomStyles()
    this.debugSettings()

    this.rendered = false
  }

  destroy() {
    //reset state
    this.popover.close()
    this.popover.setActive(false)

    this.channelPicker.close()

    // TODO change toggle state logic
    // if (!this.bubble.isClosed()) {
    //   this.bubble.toggleState()
    // }

    //reset channels
    this.$windowContentElement.innerHTML = ''

    //reset styles
    this.$widgetContainerElement.classList.remove(`${this.styleNamespace}--placement-${this.settings.placement}`)

    //remove bubble
    this.$bubbleElement.innerHTML = ''
  }

  render() {
    if (this.rendered) {
      return
    }
    widgetManager.setWidgetTab('trueengage.channel_picker')
    this.$widgetContainerElement.classList.add(`minimized`)

    const widgetKey = `trueengage-widget-opened-${this.settings.id}`
    const isWidgetOpened = localStorage.getItem(widgetKey) === 'true'
    this.bubble.render(isWidgetOpened)

    this.chatAutoStart = false
    const genesysWebMessengerChannel = this.settings.channels.find((channel) => channel.type === 'genesysWebMessenger')
    if (genesysWebMessengerChannel && genesysWebMessengerChannel.params && genesysWebMessengerChannel.params.configuration) {
      this.chatAutoStart = genesysWebMessengerChannel.params.configuration.autoStart
    }
    this.callPopover.render()
    if (!this.isQuickRepliesActive) {
      this.popover.render()
    }
    this.channelPicker.render()
    if ((this.channels.length === 1 && this.singleChannelBehavior === SingleChannelBehavior.OPEN_PICKER) || this.channels.length > 1) {
      this.channelPickerFooter.render()
    }

    this.executeCustomJs()
    this.customStylesInit()

    this.rendered = true
    const chatId = this.getChatId()
    if (this.settings.triggers.length > 0) {
      if (chatId && this.settings.headsUpType === 'quickReplies') {
        widgetManager.openChannel(chatId)
      }
    }
    const chatChannel = this.settings.channels.find((c) => c.displayType === 'chat')
    const hasChatInteraction = Boolean(localStorage.getItem(widgetKey))
    const hasSocials = this.settings.channels.some((c) => {
      return ['genesysWhatsapp', 'facebookMessenger'].includes(c.type)
    })
    let showInput = getAdditionalSettingValue(this.settings.additionalSettings, 'show_input_message_view')

    const openAndSetTab = (tab) => {
      widgetManager.openWidget()
      widgetManager.setWidgetTab(tab)
    }

    if (isWidgetOpened) {
      if (hasSocials && this.channels.length === 1 && !showInput) {
        widgetManager.setState({ component_state: 'loaded' })
        return
      }
      widgetManager.openWidget()

      const activeChannel = this.container.getActiveChannel(this.settings.id)
      if (activeChannel && activeChannel.type === 'chat') {
        widgetManager.setWidgetTab('trueengage.chat')
      } else if (hasChatInteraction && chatChannel) {
        widgetManager.openChannel(chatChannel.id)
      } else if (this.channels.length === 1 && this.singleChannelBehavior === SingleChannelBehavior.OPEN_CHANNEL) {
        const selectedChannel = this.channels[0]
        switch (selectedChannel.channelType) {
          case 'callback': {
            const suffix = selectedChannel.callMeNowActive ? '' : '.schedule'
            openAndSetTab(`trueengage.callback${suffix}`)
            break
          }
          default:
            openAndSetTab(`trueengage.${selectedChannel.channelType}`)
            break
        }
      }
    } else if (hasChatInteraction && chatChannel && !this.isQuickRepliesActive) {
      widgetManager.openChannel(chatChannel.id)
    }
    widgetManager.setState({ component_state: 'loaded' })
  }

  customStylesInit() {
    const channelsLength = this.settings.channels.length

    if (channelsLength === 1 && this.singleChannelBehavior === SingleChannelBehavior.OPEN_CHANNEL) {
      const footerMenu = this.$widgetContainerElement.querySelector('.cce-widget__window__footer__menu')
      const bubbleElement = this.$widgetContainerElement.querySelector('.cce-widget__bubble')

      if (footerMenu) {
        footerMenu.classList.add('cce-widget__window__footer__menu--hide')
      }

      if (bubbleElement) {
        bubbleElement.classList.add('cce-widget__bubble--oneChannel')
      }
    }
  }

  handleOpenChatWithQuickReply() {
    const chatId = this.getChatId()
    if (chatId) {
      widgetManager.setWidgetTab('trueengage.chat')
      this.closeQuickReplies()
    }
  }

  closeQuickReplies() {
    const quickRepliesElement = document.querySelector('.cce-widget__quick-replies')
    if (quickRepliesElement) quickRepliesElement.classList.remove('cce-widget__quick-replies--open')
  }

  handleCallWindow(minimized) {
    const audioCallActive = document.querySelector('.cce-widget-audio')
    const videoCallActive = document.querySelector('.cce-widget-video')
    const callPopover = document.querySelector('.cce-widget__call__popover')
    if (minimized) {
      callPopover.classList.remove('open')
      return
    }

    const showElements = (audio, video) => {
      document.querySelector('.openAudioWindow').classList.toggle('show', audio)
      document.querySelector('.audioCallWithConsultant').classList.toggle('show', audio)
      document.querySelector('.openVideoWindow').classList.toggle('show', video)
      document.querySelector('.videoCallWithConsultant').classList.toggle('show', video)
    }

    if (audioCallActive && (audioCallActive.classList.contains('ringing') || audioCallActive.classList.contains('in-progress'))) {
      callPopover.classList.add('open')
      showElements(true, false)
    } else if (videoCallActive && (videoCallActive.classList.contains('ringing') || videoCallActive.classList.contains('in-progress'))) {
      callPopover.classList.add('open')
      if (videoCallActive.classList.contains('justAudio')) {
        showElements(true, false)
      } else {
        showElements(false, true)
      }
    }
  }

  showNotification(content) {
    const notification = document.querySelector('.cce-widget__window__notification')

    notification.innerHTML = content

    notification.classList.add('show')
    notification.classList.remove('hide')

    setTimeout(() => {
      notification.classList.add('hide')
      notification.classList.remove('show')

      setTimeout(() => {
        notification.innerHTML = ''
      }, 500)
    }, 2000)
  }

  hasInteractionForm(chatChannel) {
    const chatForm = window.localStorage.getItem('cce-widget-chat-form-data')
    return (
      !chatForm &&
      Object.keys(this.settings.preInteractionForm).length > 0 &&
      this.settings.preInteractionForm.chat.enabled &&
      chatChannel.params.configuration['autoStart'] &&
      chatChannel.params.configuration['autoStart'].toString() !== 'true'
    )
  }

  handleBubbleClicked() {
    if (widgetManager.isHeadsUpVisible()) {
      widgetManager.closeHeadsup()
    }

    const mainWindow = document.querySelector('.cce-widget__window')

    mainWindow.classList.remove('full_screen')

    this.isQuickRepliesActive = false
    this.closeQuickReplies()

    if (
      this.settings.channels.length === 1 &&
      this.settings.channels[0].displayType === 'custom' &&
      this.singleChannelBehavior === SingleChannelBehavior.OPEN_CHANNEL
    ) {
      widgetManager.setWidgetTab(`trueengage.${this.settings.channels[0].customName}`, false)
      if (this.settings.channels[0].customName === 'meetingSchedule' || this.settings.channels[0].customName === 'form') {
        widgetManager.setWidgetTab('trueengage.channel_picker')
      }
      return
    }

    const activeChannel = widgetManager.getWidgetChannelInfo().channel
    const isWidgetVisible = widgetManager.isWidgetVisible()
    const currentTab = widgetManager.getWidgetTab()
    const selectedChannel = this.channels[0]
    if (!selectedChannel) return

    const isSocial = ['whatsapp', 'facebookMessenger'].includes(selectedChannel.channelType)
    const showInput = getAdditionalSettingValue(this.settings.additionalSettings, 'show_input_message_view')
    if (this.settings.channels.length === 1 && this.singleChannelBehavior === SingleChannelBehavior.OPEN_CHANNEL && isSocial && !showInput) {
      widgetManager.setWidgetTab(`trueengage.${selectedChannel.channelType}`)
      return
    }

    const openAndSetTab = (tab) => {
      widgetManager.openWidget()
      widgetManager.setWidgetTab(tab)
    }

    if (this.channels.length === 1 && this.singleChannelBehavior === SingleChannelBehavior.OPEN_CHANNEL && activeChannel === 'channel_picker') {
      switch (selectedChannel.channelType) {
        case 'chat':
          if (this.hasInteractionForm(selectedChannel)) {
            openAndSetTab('trueengage.chat.pre-interaction-form')
          } else {
            openAndSetTab('trueengage.chat')
          }
          break

        case 'callback': {
          const suffix = selectedChannel.callMeNowActive ? '' : '.schedule'
          openAndSetTab(`trueengage.callback${suffix}`)
          break
        }

        default:
          if (isSocial ? showInput : true) {
            openAndSetTab(`trueengage.${selectedChannel.channelType}`)
          }
          break
      }
    } else if (activeChannel || currentTab === 'trueengage.channel_picker') {
      isWidgetVisible ? widgetManager.closeWidget() : widgetManager.openWidget()
      if (!isWidgetVisible && currentTab !== 'trueengage.chat' && [...document.querySelectorAll('.chat__notification')].some((div) => div.textContent > 0)) {
        widgetManager.setWidgetTab('trueengage.chat')
      }
    }

    this.customStylesInit()
  }

  async handleUpgradeChat(type = 'video') {
    const videoChannelInitializedBefore = document.querySelector('.cce-widget-video')
    if (videoChannelInitializedBefore) {
      await videoChannelInitializedBefore.remove()
      window.trueengage.widgetContainer.triggerPublicEvent('remove_audio_channel_initalize')
    }
    await this.initVideoFromChatChannel(type)

    const channelContainer = this.$windowContentElement.querySelector(`.cce-widget-video`)
    channelContainer.classList.add('open', 'chatCall', `${type === 'audio' && 'justAudio'}`)
    this.$windowElement.classList.add(`cce-widget__window--with-channel`, `cce-widget__window--with-channel-chat`)
    this.$windowElementHeader.classList.add(`cce-widget__window__header-chat`, `cce-widget__window__header-chat-upgrade`)
    this.$bubbleElement.classList.add(`cce-widget__bubble--with-chat`, `cce-widget__bubble--with-channel`)

    document.querySelectorAll('.cce-widget__window__footer__menu__option').forEach((menu) => {
      if (menu.getAttribute('data-channel-type') === 'chat') {
        menu.classList.add('cce-widget__window__footer__menu__option-open')
      } else {
        menu.classList.remove('cce-widget__window__footer__menu__option-open')
      }
    })
    this.channelPicker.close()
  }

  handleChannelPickerClosed() {
    Array.from(this.$windowElementOpenChannel).forEach((button) => {
      button.classList.remove('cce-widget__window__footer__menu__option-open')
    })
    const widgetContainerElement = this.$widgetContainerElement.getElementsByClassName('cce-widget__window__header')
    Array.from(widgetContainerElement).forEach((headerElement) => {
      headerElement.classList.remove(...headerElement.classList)
      headerElement.classList.add('cce-widget__window__header')
    })
  }

  getVisitorStatus() {
    return this.container.visitor.status
  }

  initiateAction(peActionName) {
    let trigger
    this.usingPredictiveEngagement = true
    if (peActionName == 'ShowBubble') {
      trigger = {
        id: -1,
        component: 'bubble',
        kind: 'load',
        value: '20',
        playsSound: false,
      }
      this.fireTrigger(trigger)
    }
    if (peActionName == 'ShowHeadsup') {
      trigger = {
        id: -2,
        component: 'popover',
        kind: 'load',
        value: '20',
        playsSound: false,
      }
      this.fireTrigger(trigger)
    }
    if (peActionName == 'ShowWidget') {
      trigger = {
        id: -3,
        component: 'popup',
        kind: 'load',
        value: '20',
        playsSound: false,
      }
      this.fireTrigger(trigger)

      // TODO change toggle state logic
      // if (this.bubble.isClosed()) {
      // this.bubble.toggleState()
      // }
    }
  }

  initiateActions() {
    this.settings.triggers.forEach((trigger) => {
      if (trigger.kind === 'load') {
        if (this.container.setActiveWidget('load', this)) {
          setTimeout(() => {
            this.fireTrigger(trigger)
          }, 1)
        }
      }
      if (trigger.kind === 'totalTimeSpent') {
        let timeSpentOnWidget = parseInt(this.container.visitor.timesOnWidgets[this.settings.id]) || 0
        let delay = Math.max(0, parseInt(trigger.value) - timeSpentOnWidget)
        setTimeout(
          () => {
            this.triggerTotalTimeSpent(trigger)
          },
          Math.max((delay - 3) * 1000, 0)
        )
      }
      if (trigger.kind === 'timeSpent') {
        setTimeout(
          () => {
            this.triggerTimeSpent(trigger)
          },
          parseInt(trigger.value) * 1000
        )
      }
    })

    const firedBubbleTriggers = _.filter(this.getFiredTriggers(), function (t) {
      return t.component === 'bubble' || t.component === 'popover '
    })
    if (firedBubbleTriggers.length === 0) {
    } else if (this.settings.closingMode !== 'disabled' && this.getVisitorStatus() === 'closed') {
      return setTimeout(this.close, 1)
    }
  }

  triggerTotalTimeSpent(trigger) {
    if (!this.container.setActiveWidget('totalTimeSpent', this)) {
      return
    }
    return setTimeout(
      (function (_this) {
        return function () {
          return _this.fireTrigger(trigger)
        }
      })(this),
      1
    )
  }

  triggerTimeSpent(trigger) {
    if (!this.container.setActiveWidget('timeSpent', this)) {
      return
    }
    return setTimeout(() => {
      this.fireTrigger(trigger)
    }, 1)
  }

  triggerScrollPercentage(trigger) {
    if (!this.container.setActiveWidget('scrollPercentage', this)) {
      return
    }
    if (trigger.triggeredScrollPercentage) {
      return
    }
    trigger.triggeredScrollPercentage = true
    return setTimeout(() => {
      this.fireTrigger(trigger)
    })
  }

  triggerExitIntent() {
    var trigger
    trigger = _.find(
      this.settings.triggers,
      (function (_this) {
        return function (t) {
          return t.kind === 'exitIntent'
        }
      })(this)
    )
    if (trigger && this.container.setActiveWidget('exitIntent', this)) {
      return this.fireTrigger(trigger)
    }
  }

  getFiredTriggers() {
    const triggers = this.settings.triggers
    return _.filter(
      _.map(this.firedTriggerIds, function (id) {
        return _.find(triggers, function (trigger) {
          return trigger.id === id
        })
      }),
      function (trigger) {
        return trigger
      }
    )
  }

  canFireTrigger(trigger) {
    if (['bubble', 'popover'].indexOf(trigger.component) > -1 && this.state.indexOf('popup') > -1) {
      return false
    } else if (trigger.component === 'bubble' && this.state === 'popover') {
      return false
    }

    if (this.firedTriggerIds.indexOf(trigger.id) > -1 && trigger.kind === 'exitIntent') {
      return false
    }

    return (
      (this.settings.triggerFireingMode === 'fire_triggers_independently' && this.firedTriggerIds.indexOf(trigger.id) === -1) ||
      ((trigger.component === 'bubble' || trigger.component === 'popover') &&
        !(this.settings.closingMode !== 'disabled' && this.getVisitorStatus() === 'closed')) ||
      !_.any(this.getFiredTriggers(), function (firedTrigger) {
        return firedTrigger.component === trigger.component
      })
    )
  }

  fireTrigger(trigger) {
    if (trigger.component === 'hide') {
      widgetManager.closeWidget()
      widgetManager.hideIcon()
      return
    }

    logger.info('[trigger] fireTrigger ', trigger)
    if (!this.container.canFireTriggerForFilter(trigger, this.settings.filterId)) {
      logger.info("[trigger] CAN'T FIRE TRIGGER FOR FILTER")
      return
    }
    if (!this.canFireTrigger(trigger)) {
      logger.info("[trigger] CAN'T FIRE TRIGGER")
      return
    }

    this.firedTriggerIds.push(trigger.id)
    const cookieName = this.container.cookieName + '-widget-' + this.settings.id
    localStorage[cookieName] = JSON.stringify(this.firedTriggerIds)
    this.container.handleTriggerFired(trigger, this.settings.filterId)

    switch (trigger.component) {
      case 'bubble':
        widgetManager.showIcon()
        if (trigger.playsSound) widgetManager.playSound('interest')
        break
      case 'popover':
        const shouldShowHeadsup = !this.headsupAlreadyShown || this.popover.headsupAlwaysActive

        if (shouldShowHeadsup && this.popover.isActive && this.settings.headsUpType === 'text') {
          this.triggerPublicEvent('engagement_headsup', {})
          widgetManager.openHeadsup()
          if (trigger.playsSound) widgetManager.playSound('interest')
          this.headsupAlreadyShown = true
        }
        break
      case 'popup':
        widgetManager.openWidget()
        this.triggerPublicEvent('engagement_widget', {})
        if (trigger.playsSound) widgetManager.playSound('interest')
        break
      case 'bubbleAnimation':
        widgetManager.showAnimation()
        if (trigger.playsSound) widgetManager.playSound('interest')
        break
      default:
        widgetManager.playSound()
        break
    }
  }

  debugSettings() {
    let props = {
      'Widget ID': this.settings.id.toString(),
      'Target Group ID': this.settings.filterId.toString(),
      'Visitor Status': this.settings['visitorStatus'] || '',
      'Consultant Availability': this.settings.isAvailableOffline
        ? 'available'
        : this.container.settings.mode === 'callback'
          ? 'unavailable (shows scheduling mode outside of working hours)'
          : `unavailable (but ignored in ${this.container.settings.callKind} call execution method)`,
    }
    _.forEach(this.settings.triggers, (trigger) => {
      props[`${capitalize(trigger.component)} Trigger`] = trigger.kind
      props[`${capitalize(trigger.component)} Value`] = `${trigger.value}`
      props[`${capitalize(trigger.component)} Sound`] = trigger.playsSound ? 'on' : 'off'
    })
    this.container.printDebugInformation(`Widget #${this.settings.id}`, props)
  }

  mixColors(color1, color2, weight) {
    function d2h(d) {
      return d.toString(16)
    }

    function h2d(h) {
      return parseInt(h, 16)
    }

    weight = typeof weight !== 'undefined' ? weight : 50

    color1 = color1.replace(/#/g, '')
    color2 = color2.replace(/#/g, '')

    let color = '#'

    for (let i = 0; i <= 5; i += 2) {
      const v1 = h2d(color1.substring(i, i + 2)),
        v2 = h2d(color2.substring(i, i + 2))

      let val = d2h(Math.round(v2 + (v1 - v2) * (weight / 100.0)))

      while (val.length < 2) {
        val = '0' + val
      }

      if (val === 'NaN') {
        color += ''
      } else {
        color += val
      }
    }

    return color
  }

  setCustomStyles() {
    const isUserMobile = this.isMobile()
    if (this.settings.desktop) {
      const expectedNewColorsMap = [
        { cssVariable: 'color-primary', propName: 'primaryColor' },
        { cssVariable: 'primary-color', propName: 'primaryColor' },

        { cssVariable: 'widget-button-background', propName: 'widgetButtonBackgroundColor' },
        { cssVariable: 'widget-button-text', propName: 'widgetButtonIconColor' },
        { cssVariable: 'widget-button-hover', propName: 'widgetButtonHoverColor' },

        { cssVariable: 'button-background', propName: 'buttonBackgroundColor' },
        { cssVariable: 'button-text', propName: 'buttonIconColor' },

        { cssVariable: 'icon-text', propName: 'channelIconColor' },
        { cssVariable: 'icon-area', propName: 'channelIconBackgroundColor' },

        { cssVariable: 'font-headerText', propName: 'headerText' },
        { cssVariable: 'font-bodyText', propName: 'channelBodyText' },
        { cssVariable: 'font-headLineText', propName: 'channelHeadlineText' },
        { cssVariable: 'font-headsUpText', propName: 'headsUpText' },

        { cssVariable: 'chat-userBackground', propName: 'chatUserBackground' },
        { cssVariable: 'chat-userText', propName: 'chatUserText' },
        { cssVariable: 'chat-consultantBackground', propName: 'chatConsultantBackground' },
        { cssVariable: 'chat-consultantText', propName: 'chatConsultantText' },
      ]

      if (!isUserMobile) {
        const lightenBgColor = this.mixColors('#FFFFFF', this.settings.desktop.buttonBackgroundColor, 80)
        const hoverButtonColor = this.mixColors('#000000', this.settings.desktop.buttonBackgroundColor, 32)
        const hoverButtonOutlineColor = this.mixColors('#FFFFFF', this.settings.desktop.buttonBackgroundColor, 88)
        document.documentElement.style.setProperty(`--custom-button-background-lighten`, `${lightenBgColor}`)
        document.documentElement.style.setProperty(`--custom-button-hover`, `${hoverButtonColor}`)
        document.documentElement.style.setProperty(`--custom-button-outline-hover`, `${hoverButtonOutlineColor}`)
      } else if (isUserMobile) {
        const lightenBgColor = this.mixColors('#FFFFFF', this.settings.desktop.buttonBackgroundColor, 80)
        const hoverButtonColor = this.mixColors('#000000', this.settings.desktop.buttonBackgroundColor, 32)
        const hoverButtonOutlineColor = this.mixColors('#FFFFFF', this.settings.desktop.buttonBackgroundColor, 88)
        document.documentElement.style.setProperty(`--custom-button-background-lighten`, `${lightenBgColor}`)
        document.documentElement.style.setProperty(`--custom-button-hover`, `${hoverButtonColor}`)
        document.documentElement.style.setProperty(`--custom-button-outline-hover`, `${hoverButtonOutlineColor}`)
      }
      expectedNewColorsMap.forEach(({ cssVariable, propName }) => {
        if (!isUserMobile) {
          if (this.settings.desktop[propName]) {
            document.documentElement.style.setProperty(`--custom-${cssVariable}`, this.settings.desktop[propName])
          }
        } else {
          if (this.settings.mobile[propName]) {
            document.documentElement.style.setProperty(`--custom-${cssVariable}`, this.settings.mobile[propName])
          }
        }
      })

      if (!isUserMobile) {
        document.documentElement.style.setProperty('--ccew-color-primary', this.settings.desktop.primaryColor)
      } else {
        document.documentElement.style.setProperty('--ccew-color-primary', this.settings.mobile.primaryColor)
      }
    } else {
      const expectedColorsMap = [
        { cssVariable: 'color-primary', propName: 'primaryColor' },
        { cssVariable: 'color-1', propName: 'color1' },
        { cssVariable: 'color-2', propName: 'color2' },
        { cssVariable: 'color-3', propName: 'color3' },
        { cssVariable: 'color-4', propName: 'color4' },
        { cssVariable: 'color-5', propName: 'color5' },
        { cssVariable: 'color-6', propName: 'color6' },
        { cssVariable: 'color-7', propName: 'color7' },
      ]

      expectedColorsMap.forEach(({ cssVariable, propName }) => {
        if (this.settings[propName]) {
          document.documentElement.style.setProperty(`--ccew-${cssVariable}`, this.settings[propName])
        }
      })
    }

    const mobilePrimaryColor = this.settings.mobile.primaryColor
    const desktopPrimaryColor = this.settings.desktop.primaryColor
    const primaryColor = isUserMobile ? mobilePrimaryColor : desktopPrimaryColor

    if (this.settings.header) {
      if (this.settings.header.type === 'gradient' && this.settings.header.gradient && this.settings.header.gradient.type === 'linear') {
        const gradientColor = this.settings.header.gradient.color
        document.documentElement.style.setProperty('--custom-header-background', `linear-gradient(63.96deg, ${primaryColor} 6.72%, ${gradientColor} 97.41%)`)
      }

      if (this.settings.header.type === 'gradient' && this.settings.header.gradient && this.settings.header.gradient.type === 'mesh') {
        document.documentElement.style.setProperty(
          '--custom-header-background',
          `radial-gradient(at -50% 0%, #ffffff 0px, transparent 50%), radial-gradient(at 140% 92%, ${this.mixColors(
            '#FFFFFF',
            primaryColor,
            100
          )} 30px, transparent 50%) ${primaryColor}`
        )
      }

      if (this.settings.header.type === 'pattern' && this.settings.header.pattern) {
        patternMap.custom = `${this.settings.header.pattern.customUrl}`
        const finalColor = `${primaryColor} url("${patternMap[this.settings.header.pattern.type]}")`

        document.documentElement.style.setProperty('--custom-header-background', `${finalColor}`)
      }

      if (this.settings.header.size && this.settings.header.size === 'small') {
        document.documentElement.style.setProperty('--custom-header-text-1', `22px`)
        document.documentElement.style.setProperty('--custom-header-text-2', `14px`)
      }
      if (this.settings.header.size && this.settings.header.size === 'medium') {
        document.documentElement.style.setProperty('--custom-header-text-1', `24px`)
        document.documentElement.style.setProperty('--custom-header-text-2', `16px`)
      }
      if (this.settings.header.size && this.settings.header.size === 'large') {
        document.documentElement.style.setProperty('--custom-header-text-1', `26px`)
        document.documentElement.style.setProperty('--custom-header-text-2', `18px`)
      }
    }

    if (this.settings.corner) {
      document.documentElement.style.setProperty('--custom-corners', `${this.settings.corner}`)
    }

    if (this.settings.channels.length === 1 && this.singleChannelBehavior === SingleChannelBehavior.OPEN_CHANNEL) {
      document.documentElement.style.setProperty(`--ccew-headsup-position-side-adjustment`, `60px`)
    }

    if (this.settings.headsUpGraphics === null) {
      document.documentElement.style.setProperty(`--ccew-popover-text-adjust`, `30px`)
    }

    let horizontalAdjustment = this.settings['adjustHorizontal']
    document.documentElement.style.setProperty(`--ccew-adjustment-horizontal`, `${horizontalAdjustment}px`)
    document.documentElement.style.setProperty(`--ccew-adjustment-vertical`, `${this.settings['adjustVertical']}px`)
    document.documentElement.style.setProperty('--ccew-text-font', `${this.settings['font'] || 'Roboto'}`)
  }

  getTemplateVariables() {
    const truncate = (string) => {
      if (!string) {
        return ''
      }
      let truncated = string.split('|')[0]
      string = string.replace('|', '')
      if (truncated.length < string.length) {
        return `<div data-role="cce-truncated-text" class="cce-truncated-text cce-truncated-text--truncated"><div class="cce-truncated-text-truncated">${truncated}</div><div class="cce-truncated-text-full">${string}</div><a href="#" class="cce-truncated-text-toggle" data-action="cce-truncated-text-toggle"></a></div>`
      } else {
        return string.replace('|', '')
      }
    }

    function simpleFormat(string) {
      return string
        .split('\n')
        .map((p) => `<p>${p}</p>`)
        .join(' ')
    }

    function dasherize(string) {
      return string.replace('_', '-')
    }

    return Object.assign({}, this.settings, {
      truncate,
      simpleFormat,
      dasherize,
    })
  }

  toggleState(state, force = false) {
    // not used?
    this.$widgetContainerElement.classList.toggle(`${this.styleNamespace}--${state}`, force)
  }

  executeCustomJs() {
    if (this.settings.customJs != null) {
      return eval('(function fn() {\n' + this.settings.customJs + '\n})()')
    }
  }

  isMobile() {
    const isMobile = /iPhone|Android|webOS|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) && !/iPad/i.test(navigator.userAgent)
    const isPhone = screen.width <= 768
    return isMobile && isPhone
  }

  close() {
    var state
    this.callbackPopupOpened = false
    this.prequalificationOutcome = null
    this.setCallbackStatus(null)
    state = this.settings.closingMode === 'minimizes' ? 'minimized' : this.settings.closingMode === 'disabled' ? 'bubble' : 'closed'
    return this.setState(state)
  }

  triggerPublicEvent(eventName, data) {
    return this.container.triggerPublicEvent(eventName, data)
  }

  handleScroll() {
    clearTimeout(this.scrollTimeout)
    return (this.scrollTimeout = setTimeout(() => this.handleDidScroll(), 200))
  }

  handleDidScroll() {
    if (this.state === 'bubble' || this.state === 'popover') {
      this.toggleState('did-scroll', true)
    }
    var scrollTop = window.scrollY
    var docHeight = document.body.scrollHeight
    var winHeight = window.innerHeight
    var scrollPercentage = Math.round((scrollTop / (docHeight - winHeight)) * 100)
    this.settings.triggers.forEach((trigger) => {
      if (trigger.kind === 'scrollPercentage' && parseFloat(trigger.value) <= scrollPercentage) {
        this.triggerScrollPercentage(trigger)
      }
    })
  }
}
